import React, { useEffect, useState } from "react";
import axios from "axios";
import { IMAGE_URL, URL_API } from "../../variable";
import {
  ClimbingBoxLoader,
  BounceLoader,
  BarLoader,
  BeatLoader,
} from "react-spinners";
import { css } from "@emotion/react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useHistory, useParams } from "react-router-dom";
import { Modal } from "react-bootstrap";

function TrimList() {
  const loaderCss = css`
    margin: auto;
  `;
  const id = useParams();
  const history = useHistory();
  const [models, setModels] = useState([]);
  const [loading, setloading] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getModels();
  }, []);

  const editModel = (id) => {
    history.push(`admin/maker/model/edit/${id}`);
  }
  const getModels = () => {
    axios.post(URL_API + `posts/vehicle/${id.id}`).then((response) => {
      if (response.data.status === 200) {
        setModels(response.data.models);
      }
    });
  };

  const destroyModel = (id) => {
    axios
      .post(URL_API + `auth/admin/modle/destroy/${id}`)
      .then((response) => {
        if (response.data.status === 200) {
          toast.success("Model Deleted Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          getModels();
        }
      });
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">
                  <strong>{models?.vehicle_name}</strong> Models
                </CardTitle>
              </CardHeader>
              <div
                style={{
                  paddingLeft: "80%",
                  paddingBottom: "2%",
                  fontSize: "16px",
                }}
              >
                <Link to={`/admin/maker/model/create-model-${id.id}-${models?.vehicle_name}`}>
                  <strong>Add Model + </strong>
                </Link>
              </div>
              <CardBody>
                <Table responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>#</th>
                      <th style={{ width: "200px" }}>Name</th>
                      <th>Image</th>
                      <th>Model Trims</th>
                      <th>Slug</th>
                      <th>Description</th>
                      <th>Created At</th>
                      <th>Action</th>
                      {/* <th className="text-right">Salary</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {models?.vehicle_modles?.map(
                      (model, index) => {
                        return (
                          <tr>
                            <td>{index + 1}</td>
                            <td>{model?.modle_name}</td>
                            <td>
                              <img
                                height="140"
                                width="140"
                                src={IMAGE_URL + model?.image}
                              />
                            </td>
                            <td><Link to={`/admin/trim-List/model/${model.id}`}>
                               <strong>TRIM LIST</strong>
                            </Link></td>
                            <td>{model?.slug}</td>
                            <td>{model?.description?.substring(0, 50)}...</td>

                            <td>
                              {moment(model?.created_at).format(
                                " DD MMMM,YYYY"
                              )}
                            </td>

                            <td>
                              {/* <a style={{color:"#77ac54"}} href={`article/detail/${tag.id}`}>
                                  <i class="fas fa-eye fa-lg"></i>
                                </a>
                                &nbsp;&nbsp; */}
                              <Link to={`edit/${model.id}`}>
                                <i class="far fa-edit fa-lg"></i>
                              </Link>
                              &nbsp;&nbsp;&nbsp;&nbsp;
                              <a
                                style={{ color: "red" }}
                                onClick={() => destroyModel(model.id)}
                              >
                                <i class="fas fa-trash-alt fa-lg"></i>
                              </a>
                            </td>
                          </tr>
                        );
                      }
                      // )
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default TrimList;
